import { useState } from "react";
import { toast } from "sonner";
import { Download, FileText } from "lucide-react";
import api from "@/lib/api";
import { Card, PageHeader, Btn } from "@/components/admin/ui";

const REPORTS = [
  { key: "workforce", label: "Workforce Report" },
  { key: "tasks", label: "Task Report" },
  { key: "leads", label: "Lead Report" },
  { key: "sales", label: "Sales Report" },
  { key: "earnings", label: "Earnings Report" },
];

export default function Reports() {
  const [preview, setPreview] = useState(null);
  const [active, setActive] = useState(null);

  const view = async (key) => {
    setActive(key);
    try { const { data } = await api.get(`/reports/${key}`); setPreview(data); }
    catch { toast.error("Could not load report."); }
  };

  const download = async (key) => {
    try {
      const res = await api.get(`/reports/${key}?format=csv`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a"); a.href = url; a.download = `gtforce_${key}.csv`; a.click();
      URL.revokeObjectURL(url);
      toast.success("CSV downloaded");
    } catch { toast.error("Export failed."); }
  };

  return (
    <div className="space-y-6">
      <PageHeader title="Reports" subtitle="Generate and export operational reports. Exports respect your permissions." />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {REPORTS.map((r) => (
          <Card key={r.key} className="p-5">
            <div className="flex items-center gap-3"><div className="h-10 w-10 rounded-lg bg-[#1D4ED8]/15 text-[#1D4ED8] grid place-items-center"><FileText size={18} /></div>
              <div className="font-head font-semibold text-white">{r.label}</div></div>
            <div className="mt-4 flex gap-2">
              <Btn variant="ghost" data-testid={`report-view-${r.key}`} onClick={() => view(r.key)}>Preview</Btn>
              <Btn data-testid={`report-download-${r.key}`} onClick={() => download(r.key)}><Download size={14} className="inline mr-1" /> CSV</Btn>
            </div>
          </Card>
        ))}
      </div>
      {preview && (
        <Card className="p-5">
          <h3 className="font-head font-semibold text-white mb-3">Preview · {active} ({preview.total} rows)</h3>
          <div className="overflow-x-auto max-h-96 cc-scroll">
            <table className="w-full text-sm">
              <thead className="border-b border-white/10"><tr>{preview.headers.map((h) => <th key={h} className="text-left px-3 py-2 text-[11px] uppercase tracking-wider text-slate-500">{h}</th>)}</tr></thead>
              <tbody>
                {preview.items.slice(0, 50).map((row, i) => (
                  <tr key={i} className="border-b border-white/5">{preview.headers.map((h) => <td key={h} className="px-3 py-2 text-slate-300">{String(row[h] ?? "—").slice(0, 30)}</td>)}</tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
